export const ENTITY = 'SPHERE';
